import React from 'react'

import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { formatter } from 'common/date'

const SentDateCell = ({ record }) => {
  const dateElem = formatter.format(record.SentDate)
  if (record.SystemState === 'delivered') {
    return (
      <Link
        to={`${import.meta.env.BASE_URL}/documents/batches/applicants?batchId=${record.Id}&batchDate=${
          record.SentDate
        }`}
      >
        {dateElem}
      </Link>
    )
  }
  return dateElem
}

SentDateCell.propTypes = {
  record: PropTypes.object.isRequired,
}

export default SentDateCell
